var _rect, _rect2, _path, _path2, _path3, _g, _path4, _rect3, _rect4, _path5, _circle, _path6, _path7, _g2, _path8, _circle2, _path9, _path10, _path11, _circle3, _path12, _rect5, _path13, _path14, _path15, _g3, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _g4, _path28, _ellipse, _ellipse2, _ellipse3, _ellipse4, _ellipse5, _circle4, _path29, _rect6, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _circle5, _circle6, _rect7, _rect8, _rect9, _path63, _path64, _path65, _g5, _path66, _path67, _g6, _ellipse6, _circle7, _circle8, _ellipse7, _ellipse8, _ellipse9, _rect10, _rect11, _path68, _rect12, _rect13, _rect14, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgExperience(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 600,
    height: 280,
    viewBox: "0 0 600 280",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3882_1716950)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 600,
    height: 280,
    fill: "#F2F8FD"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3882_1716950",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 669,
    height: 320
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 668.8,
    height: 320,
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3882_1716950)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M181.427 45.394C202.287 66.2545 243.156 116.082 295.722 144.942C389.74 196.559 634.922 154.159 590.679 320.072C584.562 343.011 395.864 363.812 244.105 323.759C200.12 312.151 111.375 235.272 111.375 235.272C111.375 235.272 56.0703 201.765 56.0703 146.785C56.0703 117.29 64.8516 81.6902 70.8181 69.3593C98.4703 12.2114 162.992 26.9593 181.427 45.394Z",
    fill: "#031D43"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M158.617 132.082C158.617 132.082 157.208 151.121 157.208 161.325C157.208 174.658 183.036 185.962 204.593 193.075C221.57 198.676 234.753 212.962 236.953 230.703L251.453 347.631H19.2891L33.7892 230.703C35.9892 212.962 49.1698 198.673 66.1611 193.117C87.7163 186.069 113.534 174.921 113.534 161.96C113.534 151.805 112.126 133.491 112.126 133.491L158.617 132.082Z",
    fill: "#CD8B52"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_3882_1716950",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 19,
    y: 132,
    width: 233,
    height: 216
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M158.617 132.082C158.617 132.082 157.208 151.121 157.208 161.325C157.208 174.658 183.036 185.962 204.593 193.075C221.57 198.676 234.753 212.962 236.953 230.703L251.453 347.631H19.2891L33.7892 230.703C35.9892 212.962 49.1698 198.673 66.1611 193.117C87.7163 186.069 113.534 174.921 113.534 161.96C113.534 151.805 112.126 133.491 112.126 133.491L158.617 132.082Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_3882_1716950)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M73.7971 169.766C73.7971 169.766 96.6055 202.488 136.076 202.115C175.546 201.743 196.945 169.766 196.945 169.766L233.284 193.567L251.453 330.371H19.2891L37.4584 195.384L73.7971 169.766Z",
    fill: "#00539D"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M99.4453 80.6592C99.4453 60.8184 115.529 44.7344 135.37 44.7344C155.211 44.7344 171.295 60.8185 171.295 80.6592V118.697C171.295 138.538 155.211 154.622 135.37 154.622C115.529 154.622 99.4453 138.538 99.4453 118.697V80.6592Z",
    fill: "#CD8B52"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 160.027,
    y: 95.4512,
    width: 21.1322,
    height: 21.1322,
    rx: 8.4529,
    fill: "#CD8B52"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 89.5859,
    y: 95.4512,
    width: 21.1322,
    height: 21.1322,
    rx: 8.4529,
    fill: "#CD8B52"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M99.4468 50.3707L134.667 37.6914L171.296 50.3707L175.523 61.6413L171.296 68.8311C171.296 68.8311 155.949 73.0658 138.894 84.8624C121.839 96.6591 99.4468 102.497 99.4468 102.497L93.8115 75.7294L99.4468 50.3707Z",
    fill: "#002242"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 154.39,
    cy: 113.767,
    r: 4.22645,
    fill: "#211E1F"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M124.804 136.311C124.804 136.311 130.087 137.219 135.37 137.219C140.653 137.219 145.936 136.311 145.936 136.311V140.945C145.936 140.945 140.653 146.488 135.37 146.488C130.087 146.488 124.804 140.945 124.804 140.945V136.311Z",
    fill: "#9D4000"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_3882_1716950",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 124,
    y: 136,
    width: 22,
    height: 11
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M124.804 136.311C124.804 136.311 130.087 137.219 135.37 137.219C140.653 137.219 145.936 136.311 145.936 136.311V140.945C145.936 140.945 140.653 146.488 135.37 146.488C130.087 146.488 124.804 140.945 124.804 140.945V136.311Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_3882_1716950)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M126.619 136.311C126.619 136.311 130.085 137.219 135.368 137.219C140.651 137.219 144.118 136.311 144.118 136.311V140.037C144.118 140.037 140.651 144.671 135.368 144.671C130.085 144.671 126.619 140.037 126.619 140.037L126.619 136.311Z",
    fill: "#9D4000"
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M135.119 129.065C137.768 129.065 140.418 128.308 140.418 129.065C140.418 129.822 137.768 132.093 135.119 132.093C132.469 132.093 129.819 129.822 129.819 129.065C129.819 128.308 132.469 129.065 135.119 129.065Z",
    fill: "#9C5620"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 116.352,
    cy: 113.767,
    r: 4.22645,
    fill: "#211E1F"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M194.125 224.904C198.246 226.168 201.77 228.81 204.256 232.331C212.312 243.738 231.763 270.723 248.635 289.776C270.548 314.521 277.247 328.435 277.247 328.435L229.427 349.691C229.427 349.691 226.267 353.205 218.629 319.361C210.991 285.517 197.883 264.396 194.891 256.386C191.898 248.376 185.841 251.404 181.299 251.404C176.757 251.404 171.603 250.792 169.638 248.827C167.672 246.861 168.803 247.248 167.672 245.347C166.541 243.446 166.158 243.833 164.268 242.063C162.377 240.292 163.987 238.21 163.262 236.832C162.719 235.8 161.616 236.263 161.616 233.234C161.616 230.206 161.616 228.692 161.616 228.692C161.616 228.692 155.559 228.692 145.832 230.922C141.58 230.922 140.418 230.29 140.418 227.178C140.418 227.178 142.216 226.35 144.96 225.664C157.073 222.636 166.158 219.607 172.214 219.607C176.184 219.607 187.085 222.743 194.125 224.904Z",
    fill: "#CD8B52"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M116.279 251.398C116.211 249.017 118.123 247.051 120.504 247.051H152.662C155.043 247.051 156.955 249.017 156.887 251.398L155.602 296.359H117.564L116.279 251.398Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M118.535 254.851C118.469 252.472 120.38 250.508 122.76 250.508H150.409C152.789 250.508 154.7 252.472 154.634 254.851L153.501 295.931H119.668L118.535 254.851Z",
    fill: "#E8E8E8"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 124.217,
    cy: 256.703,
    r: 2.27117,
    fill: "#211E1F"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.1836 320.308C40.1836 320.308 80.0371 322.606 106.805 302.883C107.882 302.113 107.051 290.523 108.319 289.256C109.833 287.742 110.263 283.135 110.156 279.798C109.978 274.245 108.109 270.598 109.216 269.38C111.205 267.192 114.735 270.168 117.563 275.015C118.972 280.651 118.202 286.925 120.486 289.209C122.77 291.493 123.438 295.429 141.618 289.314C159.799 283.199 153.742 260.488 162.54 264.417C162.878 264.568 161.313 269.572 161.313 275.629C161.313 281.685 161.313 280.171 161.313 283.199C161.313 286.228 159.799 289.256 158.284 293.798C156.77 298.341 156.77 302.883 153.742 305.911C149.2 308.939 149.825 306.956 135.573 314.996C121.32 323.036 128.002 321.052 109.216 329.182C90.429 337.312 40.1836 366.443 40.1836 366.443V320.308Z",
    fill: "#CD8B52"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 249.6,
    y: 62.4004,
    width: 97.6,
    height: 97.6,
    rx: 48.8,
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_3882_1716950",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 281,
    y: 89,
    width: 40,
    height: 58
  }, _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M289.676 89.3691H303.817C303.845 91.2779 305.388 92.9773 308.446 94.4672C320.222 100.204 320.222 110.202 320.222 119.957C320.222 130.28 318.989 138.252 316.523 143.872C315.801 145.518 314.175 146.581 312.38 146.581H290.273C288.301 146.581 286.556 145.302 285.96 143.421C282.887 133.731 281.351 124.777 281.351 116.559C281.351 109.229 286.372 101.744 288.817 94.4672C289.211 93.2926 289.497 91.5933 289.676 89.3691Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_3882_1716950)"
  }, _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M289.675 89.3691H303.816C303.844 91.2779 305.387 92.9773 308.445 94.4672C320.221 100.204 320.221 110.202 320.221 119.957C320.221 130.28 318.988 138.252 316.522 143.872C315.8 145.518 314.174 146.581 312.379 146.581H290.272C288.3 146.581 286.555 145.302 285.959 143.42C282.886 133.731 281.35 124.777 281.35 116.559C281.35 109.229 286.371 101.744 288.816 94.4672C289.21 93.2926 289.496 91.5933 289.675 89.3691Z",
    fill: "#FF7208"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask4_3882_1716950",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 285,
    y: 94,
    width: 32,
    height: 46
  }, _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M297.95 94.5352C302.122 94.5352 304.933 96.3885 303.819 98.1236C301.201 102.439 299.81 106.103 305.415 115.082C309.151 121.068 313.003 124.393 316.971 125.057L315.645 135.271C315.351 137.529 313.431 139.218 311.157 139.218H293.012C291.313 139.218 289.803 138.133 289.26 136.521C287.447 131.14 286.32 125.275 285.88 118.926C285.107 107.786 290.925 94.5352 297.95 94.5352Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_3882_1716950)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M298.183 94.3828C302.355 94.3828 305.166 96.2362 304.052 97.9712C301.434 102.287 300.043 105.951 305.648 114.93C309.385 120.916 313.237 124.241 317.204 124.905L315.878 135.119C315.585 137.377 313.664 139.066 311.39 139.066H293.245C291.546 139.066 290.037 137.981 289.494 136.369C287.68 130.988 286.554 125.123 286.113 118.774C285.34 107.634 291.158 94.3828 298.183 94.3828Z",
    fill: "#EE3E23"
  })))), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M303.816 84.8359H289.675V88.8011H303.816V84.8359Z",
    fill: "#82BA08"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M303.253 88.8027H290.242V89.3823H303.253V88.8027Z",
    fill: "#A93900"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M303.815 84.8359H298.158V88.8011H303.815V84.8359Z",
    fill: "#709608"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M302.684 78.041H290.805V85.4049H302.684V78.041Z",
    fill: "#82BA08"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M302.684 78.041H298.158V85.4049H302.684V78.041Z",
    fill: "#709608"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M306.615 102.125C303.965 103.047 303.993 108.332 306.985 113.023C309.976 117.713 312.498 119.662 314.252 118.553C316.006 117.371 315.824 113.344 313.673 107.856C311.522 102.368 308.294 101.431 306.615 102.125Z",
    fill: "#E8E8E8"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M260.752 130.003C258.285 133.012 261.078 137.252 263.288 139.773C266.081 142.99 269.76 144.843 273.868 146C280.972 147.995 290.631 146.547 296.014 141.26C299.447 137.905 300.802 135.062 299.273 130.406C298.591 128.343 298.458 126.843 300.099 125.304C300.986 124.477 301.518 124.718 300.142 124.037C298.74 123.357 298.487 123.747 297.983 125.092C296.518 128.963 296.05 133.078 293.215 136.375C290.844 139.136 286.853 140.718 283.263 141.094C274.237 142.078 265.15 137.738 260.752 130.003Z",
    fill: "#FFCD00"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M261.139 129.582C264.537 129.726 267.18 131.633 269.952 133.398C272.838 135.238 275.908 136.423 279.36 136.565C282.485 136.697 285.99 136.271 288.722 134.675C291.719 132.903 293.725 130.484 295.459 127.568C295.961 126.707 296.103 126.296 296.274 125.372C296.359 124.91 296.247 123.302 296.616 123.04C297.063 122.694 298.38 123.297 298.595 123.744C298.808 124.163 298.394 125.127 298.283 125.617C297.338 129.514 296.943 131.876 295.106 135.444C294.535 136.55 292.765 138.769 291.761 139.44C290.256 140.461 287.991 141.064 286.237 141.506C284.914 141.844 283.288 142.118 281.926 142.216C280.237 142.332 278.328 142.432 276.648 142.197C273.094 141.683 269.178 139.494 266.003 137.857C263.081 136.369 259.339 132.797 261.139 129.582Z",
    fill: "#F9E741"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M261.522 129.642C261.276 130.166 260.778 130.569 260.212 130.733C260.2 129.98 260.72 129.469 261.522 129.642Z",
    fill: "#333333"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M296.812 123.109C297.433 123.48 298.062 124.012 298.782 124.19C299.309 124.324 299.861 124.429 300.414 124.535C300.774 124.624 301.098 124.553 300.883 124.107C300.729 123.765 300.197 123.524 299.884 123.298C299.544 123.073 299.213 123.01 298.825 122.923C298.438 122.835 298.081 122.8 297.67 122.795C297.313 122.76 296.786 122.626 296.812 123.109Z",
    fill: "#333333"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M327.8 124.1C330.801 124.255 333.27 128.126 334.352 134.311C335.435 140.495 334.789 145.95 331.72 146.496C329.015 146.976 326.081 143.484 324.681 138.417C321.037 137.749 316.441 137.835 312.193 138.674C310.766 143.602 307.886 146.968 305.228 146.496C302.158 145.95 301.834 140.495 302.916 134.311C303.999 128.126 306.04 124.255 309.147 124.1C310.52 124.032 311.538 125.5 312.22 127.247C315.993 127.945 320.915 127.954 324.717 127.275C325.398 125.512 326.42 124.029 327.8 124.1Z",
    fill: "#282629"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask5_3882_1716950",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 302,
    y: 124,
    width: 33,
    height: 23
  }, _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M327.8 124.1C330.801 124.255 333.27 128.126 334.352 134.311C335.435 140.495 334.789 145.95 331.72 146.496C329.015 146.976 326.081 143.484 324.681 138.417C321.037 137.749 316.441 137.835 312.193 138.674C310.766 143.602 307.886 146.968 305.228 146.496C302.158 145.95 301.834 140.495 302.916 134.311C303.999 128.126 306.04 124.255 309.147 124.1C310.52 124.032 311.538 125.5 312.22 127.247C315.993 127.945 320.915 127.954 324.717 127.275C325.398 125.512 326.42 124.029 327.8 124.1Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5_3882_1716950)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M309.732 130.025L309.732 132.132L311.835 132.134V133.188L309.732 133.187L309.732 135.296H308.681L308.679 133.187L306.578 133.188V132.134L308.679 132.132L308.681 130.025H309.732Z",
    fill: "#C7C7C7"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.509417,
    cx: 328.707,
    cy: 133.097,
    rx: 2.10824,
    ry: 2.10256,
    transform: "rotate(-90 328.707 133.097)",
    fill: "#D8D8D8"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.509417,
    cx: 328.709,
    cy: 133.098,
    rx: 1.25909,
    ry: 1.2557,
    transform: "rotate(-90 328.709 133.098)",
    fill: "#C7C7C7"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 316.309,
    cy: 131.798,
    rx: 0.944317,
    ry: 0.941774,
    transform: "rotate(-90 316.309 131.798)",
    fill: "#E24C00"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 318.506,
    cy: 134.948,
    rx: 0.944317,
    ry: 0.941773,
    transform: "rotate(-90 318.506 134.948)",
    fill: "#9C9C9C"
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 320.703,
    cy: 131.798,
    rx: 0.944317,
    ry: 0.941773,
    transform: "rotate(-90 320.703 131.798)",
    fill: "#0071DC"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 517.637,
    cy: 208.313,
    r: 37.5652,
    fill: "#006EDF"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M517.609 185.512C515.78 185.512 514.328 186.536 514.328 187.776L515.458 200.421C515.565 201.176 516.506 201.769 517.609 201.769C518.738 201.769 519.679 201.176 519.814 200.421L520.916 187.776C520.916 186.536 519.464 185.512 517.609 185.512ZM500.372 195.866C499.297 195.245 497.683 196 496.769 197.591C495.828 199.182 495.989 200.961 497.092 201.581L508.547 206.946C509.273 207.189 510.241 206.677 510.806 205.706C511.371 204.736 511.317 203.63 510.725 203.145L500.372 195.866ZM538.18 201.581C539.255 200.961 539.417 199.182 538.502 197.591C537.561 196 535.948 195.245 534.872 195.866L524.519 203.145C523.928 203.63 523.874 204.736 524.439 205.706C525.003 206.677 525.971 207.189 526.697 206.946L538.18 201.581ZM497.092 217.731C495.989 218.378 495.828 220.157 496.769 221.748C497.683 223.339 499.297 224.094 500.372 223.473L510.725 216.194C511.317 215.682 511.371 214.576 510.806 213.606C510.241 212.635 509.273 212.123 508.547 212.393L497.092 217.731ZM526.697 212.393C525.971 212.123 525.003 212.635 524.439 213.606C523.874 214.576 523.928 215.682 524.519 216.194L534.872 223.473C535.948 224.094 537.561 223.339 538.502 221.748C539.417 220.157 539.255 218.378 538.18 217.731L526.697 212.393ZM517.636 217.568C516.506 217.568 515.565 218.134 515.458 218.889L514.328 231.534C514.328 232.801 515.78 233.825 517.609 233.825C519.464 233.825 520.916 232.801 520.916 231.534L519.814 218.889C519.679 218.134 518.738 217.568 517.636 217.568Z",
    fill: "#FFC300"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 310.397,
    y: 185.598,
    width: 123.2,
    height: 123.2,
    rx: 61.6,
    fill: "#F8F8F8"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M371.869 256.814L403.621 271.757L371.869 286.699L340.117 271.757L371.869 256.814Z",
    fill: "#D8D8D8"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M371.869 226.93L403.621 241.872L371.869 256.814L340.117 241.872L371.869 226.93Z",
    fill: "#9C5620"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M403.62 241.872L371.868 226.93V256.814L403.62 241.872Z",
    fill: "#FFC300"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M371.87 226.93L366.316 207.396L334.564 222.339L340.118 241.872L371.87 226.93Z",
    fill: "#E49800"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M371.868 226.932L403.62 241.874L408.847 222.098L377.095 207.156L371.868 226.932Z",
    fill: "#F8E6A5"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M340.117 271.757L371.869 286.699V256.815L340.117 241.873L340.117 271.757Z",
    fill: "#E49800"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M352.896 274.481V253.68L368.933 261.29L368.933 282.091L352.896 274.481Z",
    fill: "#F2ECDC"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M353.93 265.096L367.638 271.691V279.809L353.93 273.213V265.096Z",
    fill: "black"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M355.046 265.096H354.447V273.974H355.046V265.096Z",
    fill: "#F2ECDC"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M356.598 265.859H355.999V274.738H356.598V265.859Z",
    fill: "#F2ECDC"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M357.374 266.365H356.775V275.244H357.374V266.365Z",
    fill: "#F2ECDC"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M364.358 269.408H363.759V278.287H364.358V269.408Z",
    fill: "#F2ECDC"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M365.91 270.166H365.312V279.045H365.91V270.166Z",
    fill: "#F2ECDC"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M366.686 270.678H366.087V279.556H366.686V270.678Z",
    fill: "#F2ECDC"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M359.185 267.123H358.586V276.002H359.185V267.123Z",
    fill: "#F2ECDC"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M359.96 267.381H359.361V276.259H359.96V267.381Z",
    fill: "#F2ECDC"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M361.254 268.139H360.655V277.017H361.254V268.139Z",
    fill: "#F2ECDC"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M362.03 268.393H361.432V277.271H362.03V268.393Z",
    fill: "#F2ECDC"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M362.806 268.904H362.207V277.783H362.806V268.904Z",
    fill: "#F2ECDC"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M359.88 258.752L367.639 262.557V265.094L359.88 261.289V258.752Z",
    fill: "black"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M360.996 258.752H360.397V262.05H360.996V258.752Z",
    fill: "#F2ECDC"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M365.91 261.291H365.312V264.589H365.91V261.291Z",
    fill: "#F2ECDC"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M361.772 259.258H361.173V262.556H361.772V259.258Z",
    fill: "#F2ECDC"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M363.324 260.021H362.726V263.319H363.324V260.021Z",
    fill: "#F2ECDC"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M363.841 260.273H363.242V263.571H363.841V260.273Z",
    fill: "#F2ECDC"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M364.617 260.527H364.019V263.825H364.617V260.527Z",
    fill: "#F2ECDC"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M365.135 260.527H364.536V263.825H365.135V260.527Z",
    fill: "#F2ECDC"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M366.687 261.291H366.088V264.589H366.687V261.291Z",
    fill: "#F2ECDC"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M367.204 261.795H366.605V265.093H367.204V261.795Z",
    fill: "#F2ECDC"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M362.548 259.51H361.949V262.808H362.548V259.51Z",
    fill: "#F2ECDC"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M403.62 271.757V241.873L371.868 256.815V286.699L403.62 271.757Z",
    fill: "#9C5620"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M403.62 241.969L415.119 228.176L383.367 243.118L371.868 256.911L403.62 241.969Z",
    fill: "#9C5620"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M340.381 241.969L328.882 228.176L360.634 243.118L372.133 256.911L340.381 241.969Z",
    fill: "#9C5620"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 475.201,
    cy: 62.4,
    r: 78.4,
    fill: "#9B9B9B"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask6_3882_1716950",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 396,
    y: -16,
    width: 158,
    height: 157
  }, _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 475.201,
    cy: 62.4,
    r: 78.4,
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask6_3882_1716950)"
  }, _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 392.602,
    y: -85.2988,
    width: 168,
    height: 189.7,
    fill: "#89D0FE"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.4,
    x: 457.702,
    y: -15.2988,
    width: 119.7,
    height: 58.8,
    rx: 29.4,
    fill: "white"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.6,
    x: 373.002,
    y: 12.7012,
    width: 119.7,
    height: 58.8,
    rx: 29.4,
    fill: "white"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M417.102 82.6152H531.679V96.6283H507.895H496.994V92.6246L457.354 92.1241L452.4 96.6283H432.827V89.1213H417.102V82.6152Z",
    fill: "#041E42"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M501.179 55.4204C501.179 52.9111 503.213 50.877 505.722 50.877L522.446 50.877L523.233 50.877C527.33 50.877 531.068 53.1313 532.19 57.0719C532.975 59.828 533.786 63.5282 534.316 68.2216C534.563 80.8584 534.563 92.5041 534.563 92.5041H523.929L523.689 92.0232C520.806 86.2444 514.903 82.5928 508.444 82.5928H501.179V55.4204Z",
    fill: "#FFC220"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask7_3882_1716950",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 501,
    y: 50,
    width: 34,
    height: 43
  }, _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M501.179 55.4204C501.179 52.9111 503.213 50.877 505.722 50.877L522.446 50.877L523.233 50.877C527.33 50.877 531.068 53.1313 532.19 57.0719C532.975 59.828 533.786 63.5282 534.316 68.2216C534.563 80.8584 534.563 92.5041 534.563 92.5041H523.929L523.689 92.0232C520.806 86.2444 514.903 82.5928 508.444 82.5928H501.179V55.4204Z",
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask7_3882_1716950)"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M506.538 55.2112C506.538 53.9565 507.555 52.9395 508.81 52.9395H526.158C526.9 52.9395 527.593 53.3018 527.947 53.9528C528.513 54.9929 529.37 56.8093 530.042 59.2884C531.144 63.3544 531.267 74.7834 531.267 74.7834L513.957 68.6011H508.81C507.555 68.6011 506.538 67.5841 506.538 66.3294V55.2112Z",
    fill: "#041E42"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask8_3882_1716950",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 506,
    y: 52,
    width: 26,
    height: 23
  }, _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M506.538 55.2112C506.538 53.9565 507.555 52.9395 508.81 52.9395H526.158C526.9 52.9395 527.593 53.3018 527.947 53.9528C528.513 54.9929 529.37 56.8093 530.042 59.2884C531.144 63.3544 531.267 74.7834 531.267 74.7834L513.957 68.6011H508.81C507.555 68.6011 506.538 67.5841 506.538 66.3294V55.2112Z",
    fill: "white"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask8_3882_1716950)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 504.479,
    y: 48.4043,
    width: 31.7355,
    height: 7.41869,
    fill: "#8CD1FC"
  }))), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 510.9,
    cy: 94.5,
    rx: 9.68551,
    ry: 9.68551,
    fill: "#002042"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 510.9,
    cy: 94.4996,
    r: 6.38832,
    fill: "#E8E8E8"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 510.901,
    cy: 94.5012,
    r: 1.85468,
    fill: "#041E42"
  })), _ellipse7 || (_ellipse7 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 450.043,
    cy: 94.5,
    rx: 9.68552,
    ry: 9.68551,
    fill: "#041E42"
  })), _ellipse8 || (_ellipse8 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 450.043,
    cy: 94.4996,
    rx: 6.38832,
    ry: 6.38832,
    fill: "#E8E8E8"
  })), _ellipse9 || (_ellipse9 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 450.043,
    cy: 94.5012,
    rx: 1.85467,
    ry: 1.85468,
    fill: "#041E42"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 506.539,
    y: 70.6621,
    width: 7.41869,
    height: 2.4729,
    fill: "#002042"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 530.029,
    y: 66.541,
    width: 2.88505,
    height: 9.89158,
    fill: "#F9E7A1"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M531.68 90.0352H537.45V90.8595C537.45 94.0462 534.866 96.6296 531.68 96.6296V90.0352Z",
    fill: "#031D43"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 496.989,
    y: 71.8945,
    width: 4.22397,
    height: 10.9326,
    fill: "#002042"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 417.102,
    y: 41.4004,
    width: 82.0178,
    height: 41.215,
    fill: "#FF9E54"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 421.302,
    y: 45.5156,
    width: 73.5,
    height: 32.9,
    fill: "#FF7200"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3882_1716950"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 600,
    height: 280,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExperience);
export default __webpack_public_path__ + "static/media/experience.61c3a40247d6855556b7adfd9dadfdb1.svg";
export { ForwardRef as ReactComponent };